'use client';

import style from "./DegreeProgramListDetails.module.scss";

const domainList = [
    {
        id: 0,
        name: "Trending",
        filterName: "Trending"
    },
    {
        id: 1,
        name: "Management",
        filterName: "Management"
    },
    {
        id: 2,
        name: "Technology",
        filterName: "Information_Technology"
    },
    {
        id: 3,
        name: "Arts & Humanities",
        filterName: "Arts_&_Humanities"
    },
    {
        id: 4,
        name: "Commerce",
        filterName: "Commerce"
    }
];

const certificateSubDomainList = [
    {
        id: 5,
        name: "School of AI",
        filterName: "SCHOOL_OF_AI"
    },
    {
        id: 6,
        name: "KPMG",
        filterName: "KPMG"
    }
]

const DomainList = ({ setSubcourseType, subCourseType, isCertificationFilterSelected }) => {

    function updateSubcourseType(item) {
        if (item?.filterName === subCourseType?.filterName) {
            setSubcourseType(null);
        } else {
            setSubcourseType(item);
        }
    }

    return (
        (isCertificationFilterSelected ? certificateSubDomainList : domainList)?.map((item) => {
            return <span
                className={item.filterName === subCourseType?.filterName && style.active || ''}
                key={item?.id}
                onClick={() =>{
                    updateSubcourseType(item)
                    }}
                id={`domain-${item.id}`}
            >
                {item?.name}
            </span>
        })
    )
}

export default DomainList